// 엑셀 업로드(상품 일괄등록) — 타입 정의

export type MatchStatus = "성공" | "없음" | "오류";

export type ImageErrorKind = "missing" | "corrupt" | "unsupported";

/** 엑셀 한 행에서 파싱한 상품 정보 (엑셀양식.png 기준) */
export interface ParsedRow {
  rowIndex: number; // 엑셀 데이터 행 순서 (0-base)
  productCode: string;
  name: string;
  price: number | null;
  stock: number | null;
  option1: string;
  option2: string;
  description: string;
  individualDelivery: boolean;
  individualDeliveryPrice?: number;
  imageNames: string[]; // 엑셀 '이미지' 셀의 파일명들 (첫 번째=대표)
}

/** 테이블 '옵션' 컬럼 표시용 — 옵션1/옵션2 합성 */
export const optionLabel = (row: ParsedRow): string =>
  [row.option1, row.option2].filter(Boolean).join(" / ");

/** 행별 이미지 오류 1건 */
export interface RowImageError {
  fileName: string;
  kind: ImageErrorKind;
  message: string;
}

/** 매칭 성공 이미지 (미리보기용) */
export interface MatchedImage {
  name: string;
  url: string; // objectURL
}

/** 매칭 결과 테이블의 한 행 */
export interface MatchRow {
  row: ParsedRow;
  matched: MatchedImage[];
  errors: RowImageError[];
  status: MatchStatus;
}

/** 업로드된 이미지 1개 (파일명 → 엔트리) */
export interface ImageEntry {
  file: File;
  url: string; // objectURL
  corrupt: boolean;
}

/** 우측 상단 카운터 */
export interface MatchCounts {
  totalImages: number; // 업로드된 총 이미지 수
  matched: number; // 실제 상품에 매칭된 이미지 수
  unused: number; // 엑셀 리스트에 없는(사용 안 함) 이미지 수
}

/** 필터 탭 */
export type FilterTab = "전체" | "성공" | "없음" | "오류";
